'use client';
import React from 'react';
import { Icon } from './Icon';

export type Health = 'up' | 'down' | 'unknown' | 'archived';

export function HealthDot({ state = 'unknown', title }: { state?: Health; title?: string }) {
  const color =
    state === 'up' ? 'text-emerald-500' :
    state === 'down' ? 'text-red-500' :
    state === 'archived' ? 'text-orange-400' :
    'text-gray-300';
  return <Icon name="dot" className={'w-3 h-3 ' + color} />;
}
